// className 병합 헬퍼. 소비자 className 과 kit hook 클래스(`.om-*`)를 공존시킨다.
// 2단계에서 clsx + tailwind-merge 로 교체된다.
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
